/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const wasteManagementEnumsWasteInvolvedOptionEnum = {
    HazardousChemical: 'HazardousChemical',
    NonHazardousWaste: 'NonHazardousWaste',
    ConstructionWaste: 'ConstructionWaste',
    BioWaste: 'BioWaste',
    Plastic: 'Plastic',
    Cardboard: 'Cardboard',
    EWaste: 'EWaste',
    GenericMixedWaste: 'GenericMixedWaste',
    Other: 'Other',
} as const;

export type WasteManagementEnumsWasteInvolvedOptionEnumKey =
    (typeof wasteManagementEnumsWasteInvolvedOptionEnum)[keyof typeof wasteManagementEnumsWasteInvolvedOptionEnum];

export type WasteManagementEnumsWasteInvolvedOption = WasteManagementEnumsWasteInvolvedOptionEnumKey;
